var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-tag",class:_vm.color,attrs:{"status":_vm.normalized}},[_vm._v(_vm._s(_vm._f("cap")(_vm.transformType)))])
}
var staticRenderFns = []

export { render, staticRenderFns }